import { render, staticRenderFns } from "./ReferralIncentive.vue?vue&type=template&id=14947db3&"
import script from "./ReferralIncentive.vue?vue&type=script&lang=ts&"
export * from "./ReferralIncentive.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports